import React from "react";
import {
  FieldValues,
  useController,
  UseControllerProps,
} from "react-hook-form";
import { RadioGroup } from "../RadioGroup";

type InputProps = Omit<
  React.ComponentProps<typeof RadioGroup>,
  "name" | "value" | "onChange"
>;

interface FormRadioGroupProps<TFieldValues extends FieldValues>
  extends InputProps {
  name: UseControllerProps<TFieldValues>["name"];
  control: UseControllerProps<TFieldValues>["control"];
}

const FormRadioGroup = <TFieldValues extends FieldValues>({
  name,
  control,
  ...rest
}: FormRadioGroupProps<TFieldValues>) => {
  const { field, fieldState } = useController({
    name,
    control,
  });

  return <RadioGroup {...rest} {...field} error={fieldState.error?.message} />;
};

export { FormRadioGroup };
